import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  audioInfo: null,
};

const audioSlice = createSlice({
  name: 'audioInfo',
  initialState,
  reducers: {
    setAudioInfo(state, action) {
      state.audioInfo = action.payload;
    },
  },
});

export const { setAudioInfo } = audioSlice.actions;
export default audioSlice.reducer;
